// Angular
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
// Afidium
import { IFieldSpecs } from '../interfaces/field-specs';
import { MatSelect } from "@angular/material/select";

export interface IComboboxOption {
    value: any;
    label: string | number;
}

@Component({
    selector: 'combobox-field',
    template: `
        <form-field [options]="fieldConfig"
                    [formGroup]="fieldConfig.formGroup"
                    [isInternalError]="isInternalError">
            <mat-select #select
                        [disabled]="fieldConfig.disabled"
                        [formControlName]="fieldConfig.formControlName"
                        [placeholder]="fieldConfig.placeholder"
                        [class.dropdown-color-white]="dropdownColorWhite">
                <mat-option *ngFor="let item of items"
                            class="mat-option"
                            [value]="item.value"
                            (click)="onOptionSelection.emit(item.value)">
                    {{ item.label }}
                </mat-option>
            </mat-select>
        </form-field>
    `,
    styleUrls: ["./combobox-field.component.scss"]
})
export class ComboboxFieldComponent implements OnChanges {
    @Input()
    public fieldConfig: IFieldSpecs;

    @Input()
    public items: IComboboxOption[] = [];

    @Input()
    public dropdownColorWhite: boolean = false;

    @Input()
    public isInternalError: boolean = false;

    @Output()
    public onOptionSelection: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild('select')
    public select: MatSelect;

    public ngOnChanges(changes: SimpleChanges): void {

        /*if (changes.fieldConfig && changes.fieldConfig.currentValue) {
            if (this.fieldConfig.disabled) {
                this.fieldConfig.formGroup.disable({emitEvent: false});
            } else {
                this.fieldConfig.formGroup.enable({emitEvent: false});
            }
        }*/
    }

    public open(): void {
        this.select.open();
    }

}
